<template>
  <ui-flex row class="monitor-viewer-login">
    <ui-flex style="flex: 1 0 1px">
      <ui-flex col center class="monitor-viewer-login__left" style="width: 100%; height: 100%">
        <ui-logo style="height: 50px"></ui-logo>
      </ui-flex>
    </ui-flex>
    <ui-flex style="flex: 1 0 1px">
      <ui-flex col center class="monitor-viewer-login__right" style="width: 100%; height: 100%">
        <ui-container style="width: 380px; max-width: 100%">
          <ui-card class="text-center">
            <h1>监控查看者登录</h1>
            <div class="mt"></div>
            <ui-form class="mt" @keyup.enter.native.prevent="handleLogin">
              <div>
                <ui-input
                  v-model="loginForm.username"
                  placeholder="请输入用户名"
                  name="username"
                ></ui-input>
              </div>
              <div class="mt">
                <ui-input
                  v-model="loginForm.password"
                  type="password"
                  show-password
                  placeholder="请输入密码"
                  name="password"
                ></ui-input>
              </div>
              <div class="mt">
                <ui-button @click="handleLogin" type="primary" :loading="loading">登录</ui-button>
              </div>
            </ui-form>
            <div class="mt">
              <p style="color: #999; font-size: 14px; margin: 0">如有问题请联系管理员</p>
            </div>
          </ui-card>
        </ui-container>
      </ui-flex>
    </ui-flex>
  </ui-flex>
</template>

<script>
import { _ } from '@yishitec/web';

export default {
  name: 'MonitorViewerLogin',
  data() {
    return {
      loading: false,
      loginForm: {
        username: '',
        password: '',
      },
    };
  },
  methods: {
    async handleLogin() {
      try {
        if (!this.loginForm.username || !this.loginForm.password) {
          this.$message.error('请输入用户名和密码');
          return;
        }

        this.loading = true;

        const res = await this.api('/api/monitor-viewer/login', this.loginForm)();

        if (res) {
          this.$message.success(`欢迎，${res.display_name}`);
          this.$router.push('/monitor-viewer');
        }
      } catch (e) {
        this.$message.error(e.message || '登录失败');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
@import '../../assets/styles/app-mixins';

.monitor-viewer-login {
  width: 100%;
  height: 100vh;
  &__left {
    background: darken(@theme, 20);
  }
}
</style>
